<template>
  <van-config-provider :theme-vars="{ primaryColor: '#FDBB2B' }" theme-vars-scope="global">
    <RouterView />
  </van-config-provider>
</template>
<script setup lang="ts">
import { onMounted } from 'vue'
import { useGarageStore } from '@/store/garage'

const garageStore = useGarageStore()
onMounted(() => {
  if (window.location.hash.indexOf('client=pc') > -1) {
    garageStore.updateClient('pc')
  }
})
</script>

<style scoped lang="scss"></style>
